import { CmsContent, getCmsDefaults } from '@dxp/data-access'
import { decode } from 'html-entities'

import { SafeHtml } from '../safe-html'

interface IDOMParserInstance {
  parseFromString(html: string, contentType: 'text/html'): Document
}

interface IDOMParser {
  new (): IDOMParserInstance
}

export function makeCmsHtmlContentHandler(DOMParser: IDOMParser) {
  function isHTML(content: string) {
    const fragment = new DOMParser().parseFromString(content, 'text/html')
    return fragment.body.children.length > 0
  }

  const proxy: ProxyHandler<CmsContent> = {
    get(target, prop: keyof typeof getCmsDefaults, receiver) {
      const content = Reflect.get(target, prop, receiver)

      if (!content) return ''
      if (!isHTML(content)) return decode(content)

      return <SafeHtml unsafeHtml={content} />
    },
  }

  return proxy
}
